import React, { useEffect } from "react";
import { useLocation, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Box } from "@mui/material";

import Footer from "./globals/components/Footer";
import publicRoutes from "./routes/publicRoutes";
import authenticatedRoutes from "./routes/authenticatedRoutes";
import adminRoutes from "./routes/adminRoutes";

const HIDE_FOOTER_ROUTES = [
  "/",
  "/register",
  "/first-time-register",
  "/team-member-register",
  "/internal-user-register",
  "/lawfirm-user-register",
  "/professional-guardian-register",
  "/pg-contact-register",
  "/guest-request",
  "/vermost-probate-bond-request-guest",
  "/vermost-guardianship-bond-request-guest",
  "/vermost-trustee-bond-request-guest",
  "/vermost-va-bond-request-guest",
  "/vermost-blanket-bond-request-guest",
];

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  const shouldShowFooter = !HIDE_FOOTER_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(route + "/")
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Box component="main" sx={{ flex: 1 }}>
        <Routes>
          {publicRoutes}
          {authenticatedRoutes}
          {adminRoutes}
        </Routes>
      </Box>
      {shouldShowFooter && <Footer />}
      <ToastContainer />
    </Box>
  );
}

export default App;
